import {createHelpers} from 'vuex-map-fields'

const {getQueryField, updateQueryField} = createHelpers({
  getterType: 'getQueryField',
  mutationType: 'updateQueryField',
})

const getDefaultState = () => {
  return {
    search: null,
    favorite: false,
    recent: false,
    ira: false,
    activelyBuying: null,
    activelySelling: null,
    showFormulas: false,
    adminTable: false,
    hideInactive: true, // Hide products not actively buying or selling
    queryCategories: [],
  }
}

// initial state
const state = getDefaultState()

const getters = {
  getQueryField,
  getQuery: (state) => state,
  getQueryCategories: (state) => state.queryCategories,
}

const actions = {
  resetQueries({commit}) {
    commit('RESET_QUERIES')
  },
}

const mutations = {
  updateQueryField,
  UPDATE_QUERY_CATEGORIES(state, queryCategories) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    const stateToReplace = {queryCategories}
    Object.assign(state, stateToReplace)
  },
  RESET_QUERIES(state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
}
